import React, {useState, useEffect } from 'react';
import { format } from 'date-fns';
import { Button } from 'react-bootstrap';

import { adaptTimeSlots } from '../../../../utils/eventServicesUtils';
import { BulletIcon } from '../../../../components/common/BulletIcon/BulletIcon';

export const Confirmation = ({
    fromPOS=false,
    handleClose=null,
    success="",
    activeService,
    selectedBookings,
    selectedLocation,
    ...props
})=>{

    // if(fromPOS && handleClose) handleClose(); //Can add back in later if POS feels too slow with the extra screen

    const [times, setTimes]=useState({start: null, end: null});

    useEffect(()=>{
        const checkTimeSlots=async()=>{
            let time={start: null, end: null};
            let adaptedTimeSlot = await adaptTimeSlots(selectedBookings);
            time.start = format(new Date(adaptedTimeSlot?.start), "MM/dd/yy hh:mm aa");
            time.end = format(new Date(adaptedTimeSlot?.end), "MM/dd/yy hh:mm aa");
            setTimes(time)
        }

        checkTimeSlots();

    },[])

    

    return(
        <>
            {success==="Booking" && 
                <div>
                    <h5>
                        Booking Successfully Created!
                    </h5>
                    <p>
                        <BulletIcon />{activeService?.name}
                    </p>
                    <p>
                        <BulletIcon />{selectedLocation?.name}
                    </p>
                    <p>
                        <BulletIcon />{selectedBookings?.length} Timeslots {times?.start && times?.end && <span>({times.start} - {times.end})</span>}
                     </p>
                    {fromPOS ? 
                        <Button onClick={handleClose}>
                            Close
                        </Button>    
                    :
                        <p>
                            You may navigate away from this page. 
                        </p>
                    }
                </div>
            }
            {success==="LateBooking" &&
                <div>
                    <h5>
                        Past Session Booked
                    </h5>
                    <p>
                        <BulletIcon />{activeService?.name}
                    </p>
                    <p>
                        <BulletIcon />{selectedBookings?.length} Timeslots {times?.start && times?.end && <span>({times.start} - {times.end})</span>}
                    </p>
                    <p>No booking emails were sent.</p>
                    {fromPOS &&
                        <Button onClick={handleClose}>
                            Close
                        </Button>
                    }
                </div>
            }
            {success==="Cart" &&
                <p>
                    The tokens for this product have been added to the cart!
                </p>
            }
        </>
    )
}